import React from 'react';
import useMobileBreakpoint from "@arctheme-hooks/useMobileBreakpoint";

export default function ClientSuccessStory({ settings, section, columns }) {
  let isMobile = useMobileBreakpoint(settings.mobile_breakpoint);
  
  return (
    <div className={`flex-1 flex flex-col px-5 py-6 lg:px-[60px] lg:py-12 gap-6 lg:gap-10
      bg-white/10 rounded overflow-hidden backdrop-blur`}
    >
      <div className="flex flex-col gap-6 lg:max-w-[498px]">
        <div>
          <div className={`mb-2 ${isMobile ? section.story_tagline_font_type_mobile : section.story_tagline_font_type}`}>
            {section.story_tagline}
          </div>
          <div className={`${isMobile ? section.story_title_font_type_mobile : section.story_title_font_type}`}>
            {section.story_title}
          </div>
        </div>
        <div className={`${isMobile ? section.story_description_font_type_mobile : section.story_description_font_type}`}>
          {section.story_description}
        </div>
      </div>
      <div className={`flex flex-col md:grid md:grid-cols-2 ${isMobile ? "gap-4" : "gap-8"}`}>
        {columns.map((column, index) => (
          <div key={index} className="flex flex-wrap justify-center items-center align-center gap-3 lg:min-h-[142px] py-5 px-3 lg:py-2 rounded bg-[#1C1C1F] hover:bg-[#917DF1] text-white">
            <div className={`${isMobile ? column.settings.highlight_label_font_type_mobile : column.settings.highlight_label_font_type}`}>
              {column.settings.highlight_label}
            </div>
            <div className={`${isMobile ? column.settings.highlight_description_font_type_mobile : column.settings.highlight_description_font_type}`}>
              {column.settings.highlight_description}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};